import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'

import { epicActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'

export default function EpicRedirect(props) {
  const { location } = props
  const dispatch = useDispatch()
  const accessToken = useSelector(state => state.epicReducer.accessToken)

  const handleLocation = parsedLocation => {
    if (parsedLocation.search) {
      const params = parsedLocation.search.split('?')[1].split('&')
      const hashKey = params.map(param => ({
        [param.split('=')[0]]: param.split('=')[1],
      }))
      const mergedHashKeys = hashKey.reduce((acc, currentHashKey) => {
        Object.entries(currentHashKey).forEach(([key, value]) => {
          acc[key] = value
        })
        return acc
      }, {})
      return mergedHashKeys
    }
    return {}
  }
  const parsedLocation = useMemo(() => handleLocation(location), [location])
  console.log('parsedLocation', parsedLocation)

  useEffect(() => {
    dispatch(epicActions.saveParsedHash(parsedLocation))
  }, [dispatch, parsedLocation])

  const handleBtnClick = () => {
    window.close()
  }

  return (
    <div
      className="jumbotron jumbotron-fluid d-flex align-items-center justify-content-center bg-white"
      style={{ minHeight: '100vh' }}
      aria-labelledby="epic-auth-title"
    >
      <div className="container">
        <h1 className="page-title text-center" id="epic-auth-title">
          <FormattedMessage id="epic.label.authenticated" />
        </h1>
        <p className="text-center">
          <FormattedMessage
            id={accessToken ? 'epic.label.extraInstruction' : 'error.epic.account'}
          />
        </p>
        <h4 className="text-center">
          <Button
            color="dark"
            block
            outline
            onClick={handleBtnClick}
            aria-label="Close authentication window"
          >
            <FormattedMessage id="global.label.windowClose" />
          </Button>
        </h4>
      </div>
    </div>
  )
}
